export class PrescriptionEhrMatchVerification {
  id: number;
  prescriptionWrittenAtCe: boolean;
  notes: string;
  frozen: boolean;
}
